import React, { Component } from 'react'
import { Tabs, Row, Col, Form, Input, Button, Spin, Icon, Tooltip, Progress, InputNumber, Upload, message, Modal, Tag, notification} from 'antd';
import { connect } from 'react-redux';
import { uploadPostCat } from '../../../../core/actions/uploadPost';
import {bindActionCreators} from "redux"
const { TextArea } = Input;

const antIcon = <Icon type="loading" style={{ fontSize: 50 }} spin />

const openNotificationWithIcon = (type, msg, desc) => {
  notification[type]({
    message: msg,
    description: desc,
  });
};


class PostCatUpload extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      desc: '',
      loading: false,
      author: ''
    }
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err) => {
      if (!err) {
        // console.log(this.state)
        this.props.uploadPostCat(this.state)
      }
    });
  }  

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)
    const { profile, post } = nextProps
    this.setState({
      author: profile,
      loading: post.loading
    })
    if(post.uploadCatSuccess) {
      openNotificationWithIcon('success', 'Post Category Created!', post.uploadCatSuccess)
      this.props.form.resetFields()
      post.uploadCatSuccess = null
    }
    if(post.uploadCatError) {
      openNotificationWithIcon('error', 'Post Category Failed!', post.uploadCatError)
      post.uploadCatError = null
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading } = this.state
    return (
      <div className="catcpost-form">
        <Spin spinning={loading} indicator={antIcon} tip="Creating post category...">
            <Form className="cpost-form" onSubmit={this.handleSubmit}>
            <Form.Item label="Category Name">
              {getFieldDecorator('name', {
                rules: [{ required: true, message: 'Please input category name' }]
              })(
                <Input
                  name="name"
                  placeholder="Category Name"
                  onChange={(e) => this.handleChange(e)}
                />
              )}
            </Form.Item>
            <Form.Item label="Category Description">
            {getFieldDecorator('desc', {
                rules: [{ required: true, message: 'Please input category description' }]
              })(
                <TextArea
                  onChange={(e) => this.handleChange(e)}
                  placeholder="Category Description"
                  autosize={{ minRows: 3, maxRows: 5 }}
                  name="desc"
                />
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="save-btn">
                Create
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    )
  }
}

const WrappedPostCatUpload = Form.create()(PostCatUpload);

const mapStateToProps = state => ({
  profile: state.firebase.profile,
  post: state.post,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  uploadPostCat
},dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedPostCatUpload);
